/**
 * Client-side routing utilities for multi-page navigation.
 * Pages: / (index.html), /login (login.html), /app (app.html), /admin (admin.html).
 */

export const navigate = (path) => {
    window.location.href = path
}

export const guardApp = async (supabase) => {
    const { data: { session } } = await supabase.auth.getSession()
    if (!session) { navigate('/login'); return null }
    return session
}

export const guardAdmin = async (supabase, adminEmails = ['majmunka1983@gmail.com']) => {
    const { data: { session } } = await supabase.auth.getSession()
    if (!session || !adminEmails.includes(session.user.email)) {
        navigate('/app')
        return null
    }
    return session
}
